import { isPresent } from "neetocist";
import { Tooltip } from "neetoui";
import PropTypes from "prop-types";
import { mergeDeepRight } from "ramda";
import { Link } from "react-router-dom";

import Rename from "components/Rename";

import { DEFAULT_HOME_BUTTON_PROPS } from "./constants";

const LeftBlock = ({
  homeButtonProps: customHomeButtonProps,
  homeUrl,
  renameProps,
  children,
}) => {
  const homeButtonProps = mergeDeepRight(
    DEFAULT_HOME_BUTTON_PROPS,
    customHomeButtonProps
  );

  return (
    <div
      className="flex items-center gap-1 md:gap-2"
      data-testid="navigation-header-left-block"
    >
      <Tooltip
        content={homeButtonProps.tooltip.content}
        position={homeButtonProps.tooltip.position}
        touch={["hold", 500]}
      >
        <Link data-testid="home-button" to={homeUrl}>
          <div className="neeto-ui-rounded hover:neeto-ui-bg-gray-200 p-1">
            {homeButtonProps.icon}
          </div>
        </Link>
      </Tooltip>
      {isPresent(renameProps) && (
        <Rename
          dropdownItems={renameProps.dropdownItems}
          value={renameProps.value}
          {...renameProps}
        />
      )}
      {children}
    </div>
  );
};

LeftBlock.propTypes = {
  /**
   * Object containing the home button icon and the props to be passed to the tooltip of the home button.
   */
  homeButtonProps: PropTypes.shape({
    tooltip: PropTypes.shape({
      content: PropTypes.string,
      postition: PropTypes.string,
    }),
    icon: PropTypes.node,
  }),
  /**
   * URL to navigate when the home button is clicked.
   */
  homeUrl: PropTypes.string.isRequired,
  /**
   * Props to be passed to the `Rename` component. Please check the `Rename` component props for more details
   */
  renameProps: PropTypes.object,
  /**
   * To render extra content in the block.
   */
  children: PropTypes.node,
};

export default LeftBlock;
